import type { FC } from 'react';

import { Button } from '@zen/DesignSystem';

interface Props {
  isDisabled?: boolean;
  isFirstStep: boolean;
  isLastStep: boolean;
  isSubmitting: boolean;
  onBack: () => void;
  onNext: () => void;
}

const WizardFooter: FC<Props> = (props) => {
  const { isDisabled = false, isFirstStep, isLastStep, isSubmitting, onBack, onNext } = props;

  const nextButtonLabel: string = isLastStep ? 'Place booking' : 'Save and next';

  return (
    <footer
      className="flex shrink-0 items-center border-t border-grey-lighter bg-white py-4 shadow-fixed-bottom"
      data-component="wizard-footer"
    >
      <div className="mx-auto flex w-full max-w-6xl items-center justify-between px-6">
        <div>
          {!isFirstStep && (
            <Button disabled={isDisabled} onClick={onBack} variant="ghost">
              Back
            </Button>
          )}
        </div>
        <Button disabled={isDisabled} isLoading={isSubmitting} onClick={onNext} variant="primary">
          {nextButtonLabel}
        </Button>
      </div>
    </footer>
  );
};

export type { Props as WizardFooterProps };
export default WizardFooter;
